import { render, staticRenderFns } from "./SpoiledDownloadButton.vue?vue&type=template&id=2036f24c&scoped=true&"
import script from "./SpoiledDownloadButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036f24c",
  null
  
)

export default component.exports